import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import NumericPad from '../NumericPad';
import ActivityLayout from '../ActivityLayout';
import { useGameUtils } from '../../hooks/useGameUtils';

function IdentifyNumbers({ onBack, onCorrect, initialTimer = null, globalTimer = null, onGlobalTimeUp, score }) {
  const { generateRandomNumber, dominoUnicode } = useGameUtils();
  const [number, setNumber] = useState(() => generateRandomNumber(0, 9));
  const [isDomino, setIsDomino] = useState(false);
  const [emoji, setEmoji] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const handleNumericInput = (answer) => {
    if (showNext) return;
    
    const isCorrect = answer === number;
    console.log('Answer:', answer, 'Number:', number, 'IsCorrect:', isCorrect);
    
    setEmoji(isCorrect ? '🎉' : '❌');
    setShowNext(true);

    if (isCorrect) {
      console.log('Calling onCorrect to increment score');
      onCorrect();
    }
  };

  const handleNext = () => {
    setNumber(generateRandomNumber(0, 9));
    setIsDomino(!isDomino);
    setEmoji(null);
    setShowNext(false);
    setResetKey(prev => prev + 1);
  };

  const renderDisplayBox = () => (
    <Box
      sx={{
        width: 200,
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid black',
        borderRadius: '12px',
        backgroundColor: 'white',
      }}
    >
      {isDomino ? (
        <Typography
          variant="h1"
          sx={{
            fontSize: '9rem',
            lineHeight: 1,
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          {dominoUnicode[number]}
        </Typography>
      ) : (
        <Typography variant="h1" sx={{ fontSize: '9rem' }}>{number}</Typography>
      )}
    </Box>
  );

  return (
    <ActivityLayout 
      key={resetKey}
      onBack={onBack}
      timeLimit={initialTimer}
      globalTimeLimit={globalTimer}
      onTimeUp={() => {
        setEmoji('⏰');
        setShowNext(true);
      }}
      onGlobalTimeUp={onGlobalTimeUp}
      isPaused={showNext}
      score={score}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
          {renderDisplayBox()}
        </Box>

        <NumericPad onClick={handleNumericInput} disabled={showNext} emoji={emoji} />

        {/* Next Button Overlay */}
        {showNext && (
          <Box
            onClick={handleNext}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: '2rem',
            }}
          >
            {emoji} {emoji === '⏰' ? 'Time\'s up!' : 'Click to continue'}
          </Box>
        )}
      </Box>
    </ActivityLayout>
  );
}

export default IdentifyNumbers;
